import { INotesAndFiles } from "@biz/definitions/ProductDefinitions";
import { getCustomFilesSafe } from "@biz/definitions/SunSailDefinitions.util";
import { EditorRawState } from "@biz/draftEditor/EditorDefinitions";

export const NotesAndFilesReducer = {
  setNotes(old: INotesAndFiles, notes: string): INotesAndFiles {
    return {
      ...old,
      notes: {
        type: "html",
        value: notes
      }
    }
  },
  setRawNotes(old: INotesAndFiles, notes: EditorRawState): INotesAndFiles {
    return {
      ...old,
      notes: {
        type: "raw",
        value: notes
      }
    }
  },
  addCustomFile(old: INotesAndFiles, file: string): INotesAndFiles {
    return {
      ...old,
      files: [
        ...getCustomFilesSafe(old),
        file
      ]
    }
  },
  removeCustomFile(old: INotesAndFiles, fileId: string): INotesAndFiles {
    const files = getCustomFilesSafe(old);
    return {
      ...old,
      files: files.filter((f) => f !== fileId)
    }
  }
}

export function getNotesAndFilesReducer<T extends INotesAndFiles>() {
  return {
    setNotes(old: T, notes: string): T {
      return {
        ...old,
        notes: {
          type: "html",
          value: notes
        }
      }
    },
    setRawNotes(old: T, notes: EditorRawState): T {
      return {
        ...old,
        notes: {
          type: "raw",
          value: notes
        }
      }
    },
    addCustomFile(old: T, file: string): T {
      return {
        ...old,
        files: [
          ...getCustomFilesSafe(old),
          file
        ]
      }
    },
    removeCustomFile(old: T, fileId: string): T {
      const files = getCustomFilesSafe(old);
      return {
        ...old,
        files: files.filter((f) => f !== fileId)
      }
    }
  }
}